/**
 * DIEUKYDIEU.TV - CẤU TRÚC DỮ LIỆU SITEMAP CHUẨN (TREE DATA) & ARTIFACT DATA
 * Dùng chung cho toàn bộ dự án (Vanilla JS, React, Next.js, Vue)
 */

(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define([], factory);
    } else if (typeof module === 'object' && module.exports) {
        const exports = factory();
        module.exports = exports;
        if (root) {
            root.SITEMAP_TREE = exports.SITEMAP_TREE;
            root.SITEMAP_DATA = exports.SITEMAP_DATA;
            root.SitemapService = exports.SitemapService;
        }
    } else {
        const exports = factory();
        root.SITEMAP_TREE = exports.SITEMAP_TREE;
        root.SITEMAP_DATA = exports.SITEMAP_DATA;
        root.SitemapService = exports.SitemapService;
    }
}(typeof globalThis !== 'undefined' ? globalThis : (typeof self !== 'undefined' ? self : this), function () {

    /**
     * 1. CÂY CẤU TRÚC SITEMAP CHUẨN (TREE DATA)
     */
    const SITEMAP_TREE = [
        {
            "id": "nhung-cau-chuyen-than-ky",
            "name": "Những câu chuyện thần kỳ",
            "slug": "nhung-cau-chuyen-than-ky",
            "icon": "auto_awesome",
            "children": [
                { "id": "khoi-benh-than-ky", "name": "Khỏi bệnh thần kỳ", "slug": "khoi-benh-than-ky" },
                { "id": "chuyen-bien-tam-tinh", "name": "Chuyển biến tâm tính", "slug": "chuyen-bien-tam-tinh" }
            ]
        },
        {
            "id": "gioi-thieu-phap-luan-dai-phap",
            "name": "Giới thiệu Pháp Luân Đại Pháp",
            "slug": "gioi-thieu-phap-luan-dai-phap",
            "icon": "spa",
            "children": [
                { "id": "gt-chung", "name": "Giới thiệu chung", "slug": "gioi-thieu-chung" },
                {
                    "id": "pldp-viet-nam",
                    "name": "Pháp Luân Đại Pháp tại Việt Nam",
                    "slug": "tai-viet-nam",
                    "subChildren": [
                        { "id": "vn-gioi-thieu", "name": "Giới thiệu", "slug": "vn-gioi-thieu" },
                        { "id": "vn-phap-ly", "name": "Môi trường pháp lý", "slug": "moi-truong-phap-ly" },
                        { "id": "vn-faq", "name": "10 câu hỏi thường gặp", "slug": "10-cau-hoi-thuong-gap" }
                    ]
                },
                {
                    "id": "pldp-trung-quoc",
                    "name": "Pháp Luân Đại Pháp tại Trung Quốc",
                    "slug": "tai-trung-quoc",
                    "subChildren": [
                        { "id": "tq-truoc-7-1999", "name": "Trước tháng 7.1999", "slug": "truoc-thang-7-1999" },
                        { "id": "tq-sau-7-1999", "name": "Sau tháng 7.1999", "slug": "sau-thang-7-1999" }
                    ]
                },
                {
                    "id": "pldp-the-gioi",
                    "name": "Pháp Luân Đại Pháp trên thế giới",
                    "slug": "tren-the-gioi",
                    "subChildren": [
                        { "id": "tg-my", "name": "PLC tại Mỹ", "slug": "plc-tai-my" },
                        { "id": "tg-chau-a", "name": "PLC tại Châu Á", "slug": "plc-tai-chau-a" },
                        { "id": "tg-chau-au", "name": "PLC tại Châu Âu", "slug": "plc-tai-chau-au" },
                        { "id": "tg-anh-dep", "name": "Góc ảnh đẹp", "slug": "goc-anh-dep" },
                        { "id": "tg-giai-thuong", "name": "Giải thưởng", "slug": "giai-thuong" }
                    ]
                },
                {
                    "id": "danh-cho-nguoi-moi",
                    "name": "Dành cho người mới",
                    "slug": "danh-cho-nguoi-moi",
                    "subChildren": [
                        { "id": "moi-huong-dan", "name": "Hướng dẫn", "slug": "huong-dan" },
                        { "id": "moi-9-bai-giang", "name": "9 bài giảng Pháp", "slug": "9-bai-giang-phap" },
                        { "id": "moi-5-bai-cong-phap", "name": "5 bài Công Pháp", "slug": "5-bai-cong-phap" }
                    ]
                },
                { "id": "truyen-ky-nha-sang-lap", "name": "Truyền kỳ về Nhà sáng lập", "slug": "truyen-ky-nha-sang-lap" }
            ]
        },
        {
            "id": "vung-dat-con-nguoi",
            "name": "Vùng đất - Con người",
            "slug": "vung-dat-con-nguoi",
            "icon": "public",
            "children": [
                { "id": "vd-gioi-thieu", "name": "Giới thiệu", "slug": "gioi-thieu" },
                { "id": "vd-video", "name": "Video", "slug": "video" }
            ]
        },
        {
            "id": "chan-tuong-cuoc-buc-hai",
            "name": "Chân tướng cuộc bức hại",
            "slug": "chan-tuong-cuoc-buc-hai",
            "icon": "gavel",
            "children": [
                {
                    "id": "nguyen-nhan",
                    "name": "Nguyên nhân",
                    "slug": "nguyen-nhan",
                    "subChildren": [
                        { "id": "nn-noi-dung", "name": "Nội dung", "slug": "noi-dung" },
                        { "id": "nn-video", "name": "Video", "slug": "video" }
                    ]
                },
                { "id": "buc-hai-trung-quoc", "name": "Bức hại tại Trung Quốc", "slug": "buc-hai-tai-trung-quoc" },
                { "id": "dan-ap-xuyen-quoc-gia", "name": "Đàn áp xuyên quốc gia", "slug": "dan-ap-xuyen-quoc-gia" },
                { "id": "the-gioi-len-tieng", "name": "Thế giới lên tiếng", "slug": "the-gioi-len-tieng" },
                { "id": "toi-ac-dcstq", "name": "Tội ác của ĐCSTQ", "slug": "toi-ac-cua-dcstq" },
                { "id": "tin-tuc-su-kien", "name": "Tin tức - sự kiện", "slug": "tin-tuc-su-kien" }
            ]
        },
        {
            "id": "van-hoa",
            "name": "Văn hoá",
            "slug": "van-hoa",
            "icon": "palette",
            "children": [
                {
                    "id": "am-nhac-nghe-thuat",
                    "name": "Âm nhạc - Nghệ thuật",
                    "slug": "am-nhac-nghe-thuat",
                    "subChildren": [
                        { "id": "an-am-nhac", "name": "Âm nhạc", "slug": "am-nhac" },
                        { "id": "an-tho-ca", "name": "Thơ ca", "slug": "tho-ca" },
                        { "id": "an-phim-chan-tuong", "name": "Phim chân tướng", "slug": "phim-chan-tuong" },
                        { "id": "an-anh-dep", "name": "Ảnh đẹp Đại Pháp", "slug": "anh-dep-dai-phap" }
                    ]
                },
                { "id": "van-hoa-truyen-thong", "name": "Văn hoá truyền thống", "slug": "van-hoa-truyen-thong" }
            ]
        },
        {
            "id": "video",
            "name": "Video",
            "slug": "video",
            "icon": "smart_display",
            "children": [
                { "id": "vid-than-ky", "name": "Câu chuyện thần kỳ", "slug": "cau-chuyen-than-ky" },
                { "id": "vid-noi-tieng", "name": "Người nổi tiếng", "slug": "nguoi-noi-tieng" },
                { "id": "vid-the-gioi", "name": "Pháp Luân Đại Pháp trên thế giới", "slug": "pldp-tren-the-gioi" },
                { "id": "vid-su-that", "name": "Sự thật", "slug": "su-that" }
            ]
        },
        {
            "id": "su-kien",
            "name": "Sự kiện",
            "slug": "su-kien",
            "icon": "event",
            "children": [
                { "id": "sk-trong-nuoc", "name": "Trong nước", "slug": "trong-nuoc" },
                { "id": "sk-the-gioi", "name": "Thế giới", "slug": "the-gioi" },
                { "id": "sk-ky-niem", "name": "Ngày kỷ niệm", "slug": "ngay-ky-niem" },
                { "id": "sk-tin-lien-quan", "name": "Tin liên quan", "slug": "tin-lien-quan" }
            ]
        },
        {
            "id": "media",
            "name": "Media",
            "slug": "media",
            "icon": "play_circle",
            "children": [
                {
                    "id": "media-am-nhac",
                    "name": "Âm nhạc",
                    "slug": "am-nhac",
                    "subChildren": [
                        { "id": "mus-lien-tinh", "name": "Liên Tịnh", "slug": "lien-tinh" },
                        { "id": "mus-thu-hien", "name": "Thu Hiền", "slug": "thu-hien" },
                        { "id": "mus-tung-lam", "name": "Tùng Lâm", "slug": "tung-lam" },
                        { "id": "mus-mv-dac-sac", "name": "MV đặc sắc", "slug": "mv-dac-sac" },
                        { "id": "mus-chanh-kien", "name": "Chánh Kiến", "slug": "chanh-kien" },
                        { "id": "mus-nhac-trung", "name": "Nhạc Trung", "slug": "nhac-trung" },
                        { "id": "mus-khac", "name": "Khác", "slug": "khac" }
                    ]
                },
                {
                    "id": "media-video",
                    "name": "Video",
                    "slug": "video",
                    "subChildren": [
                        { "id": "vid-vung-dat-con-nguoi", "name": "Vùng đất - Con người", "slug": "vung-dat-con-nguoi" },
                        { "id": "vid-cau-chuyen-than-ky", "name": "Câu chuyện thần kỳ", "slug": "cau-chuyen-than-ky" },
                        { "id": "vid-su-that", "name": "Sự thật", "slug": "su-that" },
                        { "id": "vid-pldp-the-gioi", "name": "Pháp Luân Đại Pháp trên thế giới", "slug": "pldp-tren-the-gioi" },
                        { "id": "vid-pldp-trung-quoc", "name": "Pháp Luân Đại Pháp tại Trung Quốc", "slug": "pldp-tai-trung-quoc" },
                        { "id": "vid-phim-chan-tuong", "name": "Phim chân tướng", "slug": "phim-chan-tuong" }
                    ]
                },
                {
                    "id": "media-audio",
                    "name": "Audio",
                    "slug": "audio",
                    "subChildren": [
                        { "id": "aud-am-nhac-dai-phap", "name": "Âm nhạc Đại Pháp", "slug": "am-nhac-dai-phap" },
                        { "id": "aud-nhac-khong-loi", "name": "Nhạc không lời", "slug": "nhac-khong-loi" },
                        { "id": "aud-phat-thanh", "name": "Phát thanh", "slug": "phat-thanh" }
                    ]
                },
                {
                    "id": "media-hinh-anh",
                    "name": "Hình ảnh",
                    "slug": "hinh-anh",
                    "subChildren": [
                        { "id": "gal-pldp-the-gioi", "name": "Pháp Luân Đại Pháp trên thế giới", "slug": "pldp-tren-the-gioi" },
                        { "id": "gal-pldp-viet-nam", "name": "Pháp Luân Đại Pháp tại Việt Nam", "slug": "pldp-tai-viet-nam" },
                        { "id": "gal-hoi-hoa", "name": "Hội họa", "slug": "hoi-hoa" }
                    ]
                }
            ]
        }
    ];

    /**
     * 2. KHO BÀI VIẾT PHONG PHÚ MỖI DANH MỤC TỐI THIỂU 5 BÀI CHẤT LƯỢNG CAO
     */
    const SITEMAP_DATA = [
        {
            id: 'nhung-cau-chuyen-than-ky',
            name: 'Những câu chuyện thần kỳ',
            slug: 'nhung-cau-chuyen-than-ky',
            icon: 'auto_awesome',
            children: SITEMAP_TREE[0].children,
            articles: [
                {
                    id: 101,
                    title: 'Hồi phục thần kỳ sau 10 năm liệt giường nhờ thực hành thiền định',
                    desc: 'Một câu chuyện có thật được các bác sĩ và gia đình chứng kiến về sự kỳ diệu của sinh mệnh khi quay về với bản tính thiện lương.',
                    tag: 'Khỏi bệnh thần kỳ',
                    duration: '6 phút đọc',
                    author: 'Nghi Vân',
                    source: 'Tân Thế Kỷ',
                    sourceUrl: 'https://tantheky.com',
                    img: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 102,
                    title: 'Từ giám đốc nóng tính trở thành người hòa ái và bao dung',
                    desc: 'Sự chuyển biến nội tâm kỳ diệu đã cứu vãn một cuộc hôn nhân trên bờ vực đổ vỡ và mang lại môi trường làm việc đầy ấm áp.',
                    tag: 'Chuyển biến tâm tính',
                    duration: '5 phút đọc',
                    img: 'https://images.unsplash.com/photo-1497215728101-856f4ea42174?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 103,
                    title: 'Bí ẩn của ý thức và cấu trúc phân tử của tinh thể nước',
                    desc: 'Khám phá chấn động từ các nhà khoa học: Ý niệm thiện hay ác của con người có tác động trực tiếp cải biến vật chất xung quanh.',
                    tag: 'Chuyển biến tâm tính',
                    duration: '7 phút đọc',
                    img: 'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 104,
                    title: 'Thoát khỏi căn bệnh ung thư di căn giai đoạn cuối',
                    desc: 'Bác sĩ từng lắc đầu từ chối điều trị, nhưng niềm tin và sự buông bỏ thù hận đã mở ra một trang đời mới tràn đầy ánh sáng.',
                    tag: 'Khỏi bệnh thần kỳ',
                    duration: '8 phút đọc',
                    img: 'https://images.unsplash.com/photo-1511895426328-dc8714191300?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 105,
                    title: 'Kỳ tích sống sót kỳ lạ sau tai nạn giao thông thảm khốc',
                    desc: 'Lời niệm chân thành trong thời khắc ngàn cân treo sợi tóc đã mang lại phép màu cứu sống cả gia đình giữa hiểm cảnh.',
                    tag: 'Khỏi bệnh thần kỳ',
                    duration: '5 phút đọc',
                    img: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 106,
                    title: 'Bác sĩ phẫu thuật phục hồi thị lực hoàn toàn mà không cần can thiệp dao kéo',
                    desc: 'Căn bệnh thoái hóa hoàng điểm tưởng chừng vô phương cứu chữa đã đảo chiều kỳ diệu sau vài tháng kiên trì luyện công.',
                    tag: 'Khỏi bệnh thần kỳ',
                    duration: '7 phút đọc',
                    img: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 107,
                    title: 'Gia đình đoàn tụ và hòa thuận sau 15 năm tranh chấp tài sản căng thẳng',
                    desc: 'Khi một người chủ động lùi một bước và thực hành chữ "Nhẫn", những bức tường định kiến trong gia tộc đã hoàn toàn sụp đổ.',
                    tag: 'Chuyển biến tâm tính',
                    duration: '6 phút đọc',
                    img: 'https://images.unsplash.com/photo-1511895426328-dc8714191300?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 108,
                    title: 'Hiện tượng cận tử (NDE) và bằng chứng y khoa về sự tồn tại của linh hồn',
                    desc: 'Những hồi ức chân thực từ hàng trăm bệnh nhân tim ngừng đập đã thách thức các quan niệm vật chất thô sơ của con người hiện đại.',
                    tag: 'Chuyển biến tâm tính',
                    duration: '8 phút đọc',
                    img: 'https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 109,
                    title: 'Hóa giải chứng trầm cảm kinh niên và tìm lại niềm vui sống mỗi ngày',
                    desc: 'Không cần phụ thuộc vào thuốc an thần, sự an định từ nội tâm đã giúp một cô gái trẻ bước ra khỏi bóng tối u uất.',
                    tag: 'Chuyển biến tâm tính',
                    duration: '5 phút đọc',
                    img: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&w=600&q=80'
                }
            ]
        },
        {
            id: 'gioi-thieu-phap-luan-dai-phap',
            name: 'Giới thiệu Pháp Luân Đại Pháp',
            slug: 'gioi-thieu-phap-luan-dai-phap',
            icon: 'spa',
            children: SITEMAP_TREE[1].children,
            articles: [
                {
                    id: 901,
                    title: 'Vì sao có nhân loại - Nhà sáng lập Pháp Luân Đại Pháp',
                    desc: 'Bài viết chấn động thế giới của Đại Sư Lý Hồng Chí, tiết lộ thiên cơ vì sao nhân loại tồn tại, cội nguồn sinh mệnh và con đường cứu độ trong thời mạt thế.',
                    tag: 'Tác phẩm kinh điển',
                    duration: '10 phút đọc',
                    img: 'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?auto=format&fit=crop&w=800&q=85',
                    externalUrl: 'https://mb.dkn.tv/bai-viet-cua-dai-su-ly-hong-chi/nha-sang-lap-phap-luan-cong-cong-bo-bai-viet-vi-sao-co-nhan-loai.html'
                },
                {
                    id: 201,
                    title: 'Pháp Luân Đại Pháp là gì? Nền tảng Chân - Thiện - Nhẫn',
                    desc: 'Môn khí công tu luyện cổ truyền của Phật gia giúp nâng cao sức khỏe thể chất và thăng hoa chuẩn mực đạo đức cho hàng trăm triệu người.',
                    tag: 'Giới thiệu chung',
                    duration: '5 phút đọc',
                    img: 'https://images.unsplash.com/photo-1544717305-2782549b5136?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 202,
                    title: 'Hướng dẫn 5 bài công pháp nhẹ nhàng, thư thái',
                    desc: 'Các động tác khoan thai, phối hợp thân tâm giúp khai thông kinh mạch, giảm stress và đem lại nguồn năng lượng dồi dào.',
                    tag: '5 bài Công Pháp',
                    duration: '12:40 xem',
                    img: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 203,
                    title: 'Pháp Luân Công được đón nhận và vinh danh tại hơn 100 quốc gia',
                    desc: 'Từ Bắc Mỹ, Châu Âu đến Châu Á, các chính phủ và tổ chức quốc tế đã trao tặng hàng ngàn bằng khen tôn vinh vì sức khỏe nhân loại.',
                    tag: 'PLC tại Mỹ',
                    duration: '6 phút đọc',
                    img: 'https://images.unsplash.com/photo-1532094349884-543bc11b234d?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 204,
                    title: 'Môi trường pháp lý và quyền tự do tín ngưỡng tại Việt Nam',
                    desc: 'Tìm hiểu các quy định pháp luật hiện hành và quyền thực hành luyện tập nâng cao sức khỏe được bảo hộ theo hiến pháp.',
                    tag: 'Môi trường pháp lý',
                    duration: '7 phút đọc',
                    img: 'https://images.unsplash.com/photo-1497215728101-856f4ea42174?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 205,
                    title: '9 bài giảng Pháp: Cẩm nang chỉ đạo tu dưỡng tâm tính chân chính',
                    desc: 'Nguyên lý cao thâm nhưng diễn giải bình dị, mở ra con đường tìm về bản nguyên sinh mệnh và thấu suốt mục đích đời người.',
                    tag: '9 bài giảng Pháp',
                    duration: '10 phút đọc',
                    img: 'https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 206,
                    title: 'Pháp Luân Đại Pháp tại Việt Nam: Những nụ cười bình an giữa đời thường',
                    desc: 'Hành trình lan tỏa những giá trị đạo đức truyền thống và sức khỏe lành mạnh đến các cộng đồng tại nhiều tỉnh thành.',
                    tag: 'Giới thiệu',
                    duration: '6 phút đọc',
                    img: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 207,
                    title: 'Giải đáp 10 câu hỏi thường gặp nhất của người mới tìm hiểu môn tập',
                    desc: 'Tập Pháp Luân Công có mất tiền không? Có cần ăn chay không? Mọi thắc mắc phổ biến đều được giải đáp rõ ràng, thấu đáo.',
                    tag: '10 câu hỏi thường gặp',
                    duration: '8 phút đọc',
                    img: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 208,
                    title: 'Những ngày đầu truyền xuất tại Trung Quốc trước tháng 7.1999',
                    desc: 'Nhìn lại thời kỳ hoàng kim khi các công viên tại Bắc Kinh, Thượng Hải, Trường Xuân rợp bóng người tập luyện và nhận được khen ngợi từ Bộ Công an Trung Quốc.',
                    tag: 'Trước tháng 7.1999',
                    duration: '9 phút đọc',
                    img: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 209,
                    title: 'Pháp Luân Công tại Châu Á: Sự đón nhận nồng nhiệt từ Đài Loan, Nhật Bản đến Hàn Quốc',
                    desc: 'Hàng ngàn trường học, doanh nghiệp đưa các bài tập tĩnh tâm vào lịch sinh hoạt để nâng cao tinh thần minh mẫn cho nhân viên.',
                    tag: 'PLC tại Châu Á',
                    duration: '5 phút đọc',
                    img: 'https://images.unsplash.com/photo-1528164344705-475426879c0d?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 210,
                    title: 'Chùm ảnh đẹp: Biển người xếp chữ Pháp Luân Đại Pháp tráng lệ',
                    desc: 'Hàng ngàn học viên trong trang phục vàng kim xếp chữ biểu tượng Chân - Thiện - Nhẫn tạo nên bức tranh thị giác rung động lòng người.',
                    tag: 'Góc ảnh đẹp',
                    duration: '4 phút đọc',
                    img: 'https://images.unsplash.com/photo-1511895426328-dc8714191300?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 211,
                    title: 'Hướng dẫn tự học tại nhà: Bắt đầu từ đâu cho người chưa từng tập khí công',
                    desc: 'Lộ trình đơn giản và chuẩn xác: Đọc sách Chuyển Pháp Luân và xem video hướng dẫn động tác hoàn toàn miễn phí.',
                    tag: 'Hướng dẫn',
                    duration: '7 phút đọc',
                    img: 'https://images.unsplash.com/photo-1497215728101-856f4ea42174?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 212,
                    title: 'Truyền kỳ về Nhà sáng lập: Hành trình thiện lành và lòng vị tha vô hạn',
                    desc: 'Những câu chuyện cảm động về Sư phụ Lý Hồng Chí trong những năm tháng truyền Pháp cứu người bình dị nhưng cao cả.',
                    tag: 'Truyền kỳ về Nhà sáng lập',
                    duration: '11 phút đọc',
                    img: 'https://images.unsplash.com/photo-1519834785169-98be25ce3e52?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 213,
                    title: 'Hơn 3000 giải thưởng và nghị quyết tôn vinh từ các chính phủ phương Tây',
                    desc: 'Các thị trưởng, thống đốc bang tại Hoa Kỳ, Canada, Úc liên tục ban hành tuyên bố biểu dương đóng góp to lớn cho sức khỏe cộng đồng.',
                    tag: 'Giải thưởng',
                    duration: '6 phút đọc',
                    img: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&w=600&q=80'
                }
            ]
        },
        {
            id: 'vung-dat-con-nguoi',
            name: 'Vùng đất - Con người',
            slug: 'vung-dat-con-nguoi',
            icon: 'public',
            children: SITEMAP_TREE[2].children,
            articles: [
                {
                    id: 301,
                    title: 'Hành trình khám phá vẻ đẹp thuần khiết khắp năm châu',
                    desc: 'Gặp gỡ những con người bình dị nhưng mang trong mình tâm hồn cao thượng và tình yêu thương vô bờ bến đối với nhân loại.',
                    tag: 'Giới thiệu',
                    duration: '6 phút đọc',
                    img: 'https://images.unsplash.com/photo-1511895426328-dc8714191300?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 302,
                    title: 'Video ký sự: Những nụ cười bình yên nơi phố thị Paris',
                    desc: 'Giữa nhịp sống hối hả, một nhóm người luyện công tĩnh lặng dưới chân tháp Eiffel đã tạo nên bức tranh an hòa tuyệt mỹ.',
                    tag: 'Video',
                    duration: '10:15 xem',
                    img: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 303,
                    title: 'Góc nhìn văn hóa từ những vùng đất ngập tràn ánh nắng nước Ý',
                    desc: 'Trải nghiệm cuộc sống chan hòa giữa thiên nhiên và tâm thức giác ngộ tại miền nam nước Ý thanh bình.',
                    tag: 'Giới thiệu',
                    duration: '5 phút đọc',
                    img: 'https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 304,
                    title: 'Khoảnh khắc an tĩnh giữa quảng trường tấp nập New York',
                    desc: 'Những giọt mồ hôi và nụ cười rạng rỡ của các học viên chia sẻ tài liệu giới thiệu môn tập đến bạn bè quốc tế.',
                    tag: 'Giới thiệu',
                    duration: '4 phút đọc',
                    img: 'https://images.unsplash.com/photo-1497215728101-856f4ea42174?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 305,
                    title: 'Video: Vẻ đẹp phong tục truyền thống xứ hoa anh đào Nhật Bản',
                    desc: 'Sự hòa quyện tuyệt vời giữa tinh thần võ sĩ đạo, lòng biết ơn cha mẹ và sự tôn kính đối với Thần linh nơi xứ Phù Tang.',
                    tag: 'Video',
                    duration: '8:45 xem',
                    img: 'https://images.unsplash.com/photo-1532094349884-543bc11b234d?auto=format&fit=crop&w=600&q=80'
                }
            ]
        },
        {
            id: 'chan-tuong-cuoc-buc-hai',
            name: 'Chân tướng cuộc bức hại',
            slug: 'chan-tuong-cuoc-buc-hai',
            icon: 'gavel',
            children: SITEMAP_TREE[3].children,
            articles: [
                {
                    id: 401,
                    title: 'Nguyên nhân vì sao ĐCSTQ phát động cuộc đàn áp năm 1999',
                    desc: 'Phân tích bản chất của cuộc bức hại xuất phát từ sự đố kỵ cá nhân của Giang Trạch Dân trước sự phổ biến rộng rãi của môn tập.',
                    tag: 'Nguyên nhân',
                    duration: '8 phút đọc',
                    img: 'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 402,
                    title: 'Các nghị quyết của Quốc hội Hoa Kỳ và Châu Âu lên án đàn áp',
                    desc: 'Cộng đồng quốc tế và các tổ chức nhân quyền liên tục ban hành các nghị quyết yêu cầu chấm dứt ngay lập tức tội ác bức hại.',
                    tag: 'Thế giới lên tiếng',
                    duration: '6 phút đọc',
                    img: 'https://images.unsplash.com/photo-1532094349884-543bc11b234d?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 403,
                    title: 'Chân tướng sự kiện tự thiêu dàn dựng tại Quảng trường Thiên An Môn',
                    desc: 'Bằng chứng phân tích từ thước phim quay chậm của đài truyền hình CNN lật tẩy màn kịch vu khống trắng trợn năm 2001.',
                    tag: 'Bức hại tại Trung Quốc',
                    duration: '9 phút đọc',
                    img: 'https://images.unsplash.com/photo-1511895426328-dc8714191300?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 404,
                    title: 'Tội ác thu hoạch tạng cưỡng bức: Vết nhơ chưa từng có trên hành tinh',
                    desc: 'Báo cáo điều tra độc lập từ luật sư David Kilgour và David Matas vạch trần thị trường cấy ghép tạng đen đẫm máu.',
                    tag: 'Tội ác của ĐCSTQ',
                    duration: '11 phút đọc',
                    img: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 405,
                    title: 'Đàn áp xuyên quốc gia: Những thủ đoạn can thiệp thầm lặng ở hải ngoại',
                    desc: 'Cảnh báo từ FBI và các cơ quan an ninh phương Tây về các hoạt động gián điệp, đe dọa các học viên Pháp Luân Công ở nước ngoài.',
                    tag: 'Đàn áp xuyên quốc gia',
                    duration: '7 phút đọc',
                    img: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&w=600&q=80'
                }
            ]
        },
        {
            id: 'van-hoa',
            name: 'Văn hoá',
            slug: 'van-hoa',
            icon: 'palette',
            children: SITEMAP_TREE[4].children,
            articles: [
                {
                    id: 501,
                    title: 'Âm nhạc thanh tao và khả năng trị liệu của ngũ âm truyền thống',
                    desc: 'Cổ nhân coi âm nhạc là phương thuốc thanh lọc tâm hồn. Ngũ cung Cung - Thương - Giác - Chủy - Vũ tương ứng với ngũ tạng.',
                    tag: 'Âm nhạc',
                    duration: '7 phút đọc',
                    img: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 502,
                    title: 'Đạo làm người và chuẩn mực đạo đức trong văn hóa phương Đông',
                    desc: 'Nhân - Lễ - Nghĩa - Trí - Tín: Những giá trị trường tồn tạo nên sự hưng thịnh của các triều đại thịnh trị xưa.',
                    tag: 'Văn hoá truyền thống',
                    duration: '6 phút đọc',
                    img: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 503,
                    title: 'Những tuyệt phẩm thơ ca ngợi ca lòng kiên trinh và đức tin',
                    desc: 'Tuyển tập những vần thơ thanh thoát, phản ánh cảnh giới siêu thoát và tĩnh tại của người tu luyện chân chính.',
                    tag: 'Thơ ca',
                    duration: '4 phút đọc',
                    img: 'https://images.unsplash.com/photo-1519834785169-98be25ce3e52?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 504,
                    title: 'Triết lý Thiên nhân hợp nhất trong kiến trúc và hội họa cổ truyền',
                    desc: 'Con người hòa hợp với đất trời, kiến trúc thuận theo tự nhiên tạo nên phong thái an hòa, ung dung tự tại.',
                    tag: 'Văn hoá truyền thống',
                    duration: '8 phút đọc',
                    img: 'https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 505,
                    title: 'Góc ảnh đẹp: Nét đẹp thần thái Chân - Thiện - Nhẫn trong đời sống',
                    desc: 'Bộ sưu tập những khoảnh khắc giàu cảm xúc của các học viên thuộc mọi lứa tuổi và sắc tộc trên toàn cầu.',
                    tag: 'Ảnh đẹp Đại Pháp',
                    duration: '5 phút xem',
                    img: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=600&q=80'
                }
            ]
        },
        {
            id: 'video',
            name: 'Video',
            slug: 'video',
            icon: 'smart_display',
            children: SITEMAP_TREE[5].children,
            articles: [
                {
                    id: 601,
                    title: 'Video: Những nhân vật nổi tiếng thế giới chia sẻ về điều kỳ diệu',
                    desc: 'Các giáo sư, nghệ sĩ và vận động viên đạt giải quốc tế chia sẻ bí quyết giúp họ luôn tràn đầy sáng tạo và bình an.',
                    tag: 'Người nổi tiếng',
                    duration: '14:20 xem',
                    img: 'https://images.unsplash.com/photo-1497215728101-856f4ea42174?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 602,
                    title: 'Phim tài liệu: Hành trình đi tìm sự thật giữa những định kiến',
                    desc: 'Những thước phim xúc động về ý chí kiên định giữ vững chính nghĩa trước mọi nghịch cảnh cuộc đời.',
                    tag: 'Sự thật',
                    duration: '28:50 xem',
                    img: 'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 603,
                    title: 'Video: Sự thay đổi kỳ diệu của một cựu tội phạm khét tiếng',
                    desc: 'Ánh sáng thiện lương đã cứu rỗi cuộc đời tăm tối, mang lại sự hoàn lương xúc động đến rơi nước mắt.',
                    tag: 'Câu chuyện thần kỳ',
                    duration: '18:15 xem',
                    img: 'https://images.unsplash.com/photo-1511895426328-dc8714191300?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 604,
                    title: 'Video: Đại hội giao lưu chia sẻ tâm đắc tu luyện quốc tế',
                    desc: 'Hàng chục ngàn đại biểu quy tụ chia sẻ những bài học sâu sắc trong việc buông bỏ cái tôi và nâng cao tâm tính.',
                    tag: 'Pháp Luân Đại Pháp trên thế giới',
                    duration: '22:30 xem',
                    img: 'https://images.unsplash.com/photo-1532094349884-543bc11b234d?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 605,
                    title: 'Phim ngắn nghệ thuật: Cây bút vẽ nên ước mơ lương thiện',
                    desc: 'Tác phẩm đoạt nhiều giải thưởng điện ảnh độc lập quốc tế về tình yêu thương gia đình và niềm tin bất diệt.',
                    tag: 'Sự thật',
                    duration: '16:40 xem',
                    img: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&w=600&q=80'
                }
            ]
        },
        {
            id: 'su-kien',
            name: 'Sự kiện',
            slug: 'su-kien',
            icon: 'event',
            children: SITEMAP_TREE[6].children,
            articles: [
                {
                    id: 701,
                    title: 'Kỷ niệm Ngày Pháp Luân Đại Pháp Thế giới 13/5 ngập tràn hoa và nụ cười',
                    desc: 'Hàng ngàn người trên khắp các châu lục cùng tham gia diễu hành và xếp chữ hoành tráng kỷ niệm ngày hồng truyền môn tập.',
                    tag: 'Ngày kỷ niệm',
                    duration: '5 phút đọc',
                    img: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 702,
                    title: 'Hội thảo quốc tế về sức khỏe toàn diện và thiền định trị liệu',
                    desc: 'Các chuyên gia y tế hàng đầu trình bày những phát hiện mới về sự kết nối giữa tâm trí, thể xác và nguồn năng lượng vũ trụ.',
                    tag: 'Thế giới',
                    duration: '6 phút đọc',
                    img: 'https://images.unsplash.com/photo-1532094349884-543bc11b234d?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 703,
                    title: 'Các hoạt động thắp nến tưởng niệm hòa bình tại các thủ phủ lớn',
                    desc: 'Ánh nến lung linh trong đêm tưởng nhớ những sinh mệnh đã ngã xuống vì bảo vệ công lý và quyền tự do tín ngưỡng.',
                    tag: 'Trong nước',
                    duration: '4 phút đọc',
                    img: 'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 704,
                    title: 'Triển lãm Nghệ thuật Quốc tế Chân Thiện Nhẫn tại Trung tâm Văn hóa',
                    desc: 'Hàng ngàn lượt khách tham quan bày tỏ sự xúc động sâu sắc trước những bức họa sơn dầu chân thực và sống động.',
                    tag: 'Tin liên quan',
                    duration: '6 phút đọc',
                    img: 'https://images.unsplash.com/photo-1519834785169-98be25ce3e52?auto=format&fit=crop&w=600&q=80'
                },
                {
                    id: 705,
                    title: 'Đoàn Nhạc Tiên Phong biểu diễn tại Lễ hội Độc lập Hoa Kỳ',
                    desc: 'Âm hưởng hùng tráng và trang phục truyền thống rực rỡ nhận được sự tán thưởng nhiệt liệt từ đông đảo khán giả.',
                    tag: 'Thế giới',
                    duration: '5 phút đọc',
                    img: 'https://images.unsplash.com/photo-1497215728101-856f4ea42174?auto=format&fit=crop&w=600&q=80'
                }
            ]
        }
    ];

    /**
     * 3. SITEMAP SERVICE UTILITIES (DÙNG CHUNG CHO FRONT-END VÀ ROUTER)
     */
    const SitemapService = {
        getTree() {
            return SITEMAP_TREE;
        },
        getAllSections() {
            return SITEMAP_DATA;
        },
        findCategoryBySlug(slug) {
            if (!slug) return null;
            const cleanSlug = slug.toLowerCase().trim();
            // Tìm cấp 1
            const parent = SITEMAP_DATA.find(s => s.slug === cleanSlug || s.id === cleanSlug);
            if (parent) return parent;

            // Tìm trong children hoặc subChildren
            for (const sec of SITEMAP_TREE) {
                if (sec.slug === cleanSlug || sec.id === cleanSlug) {
                    return SITEMAP_DATA.find(d => d.id === sec.id);
                }
                if (sec.children) {
                    for (const child of sec.children) {
                        if (child.slug === cleanSlug || child.id === cleanSlug) {
                            return { ...child, parentCategory: sec };
                        }
                        if (child.subChildren) {
                            for (const sub of child.subChildren) {
                                if (sub.slug === cleanSlug || sub.id === cleanSlug) {
                                    return { ...sub, parentCategory: sec, parentChild: child };
                                }
                            }
                        }
                    }
                }
            }
            return null;
        },
        getArticlesByCategorySlug(slug) {
            const cat = this.findCategoryBySlug(slug);
            if (!cat) return [];
            if (cat.articles) return cat.articles;
            // Nếu là mục con, lọc bài viết theo tag
            const parent = cat.parentCategory ? SITEMAP_DATA.find(d => d.id === cat.parentCategory.id) : null;
            if (parent && parent.articles) {
                return parent.articles.filter(a => a.tag === cat.name || a.tag === cat.slug);
            }
            return [];
        },
        getAllArticles() {
            const list = [];
            SITEMAP_DATA.forEach(sec => {
                if (sec.articles) list.push(...sec.articles);
            });
            return list;
        }
    };

    return {
        SITEMAP_TREE,
        SITEMAP_DATA,
        SitemapService
    };
}));
